import React, {FC, MouseEvent, useState, useEffect, ChangeEvent}  from 'react';
import {useParams} from 'react-router';
import { useNavigate } from 'react-router-dom';

// import MUI.
import NumberFormat from 'react-number-format';

// import {getYear, getMonth, getDate, isValid,differenceInCalendarYears, differenceInCalendarMonths} from 'date-fns';

import {isValid,differenceInCalendarYears, differenceInCalendarMonths, getYear, getDaysInMonth, getDaysInYear , getMonth, getDay,
  getDate, getDayOfYear, getISODay, monthsInYear,   
    addYears , addMonths, addDays, addQuarters, addWeeks, parseISO} from 'date-fns';


import {Avatar, Button, Grid, Typography, Link, Box, Paper, TextField, 
  MenuItem, IconButton, Checkbox, FormControlLabel } from '@mui/material';
import {Menu as MenuIcon, AccountCircle as AccountCircleIcon, ModeEdit as ModeEditIcon,
  Home as HomeIcon, ManageAccounts as ManageAccountsIcon, Logout as LogoutIcon, Search as SearchIcon } from '@mui/icons-material';
  import InsightsIcon from '@mui/icons-material/Insights';
import AddCircleIcon from '@mui/icons-material/AddCircle';
import PriceCheckIcon from '@mui/icons-material/PriceCheck';

import InputAdornment from '@mui/material/InputAdornment';



import { DatePicker } from '@mui/x-date-pickers';
// import library.
import { useFieldArray, useForm, useFormContext, Controller, FormProvider, FieldArrayWithId, ArrayPath } from 'react-hook-form';
import {useQuery,useQueryClient, useMutation, useQueries, UseQueryResult } from "react-query";
import { useSnackbar } from 'notistack';
import { useTranslation  } from 'react-i18next';

// import user Component
//import EnhancedTable, {EnhancedTableProps, HeadCell,EnhancedTableToolbarProps } from '../../ui/EnhancedTable';
import ArrayFieldTable, {ActionIconTableRow, HeadCell } from '../../ui/ArrayFieldTable';

import {FormDialog} from '../../ui/FormDialog';
import BasicSelectList from '../../ui/BasicSelectList';
import ArrayFieldBox from '../../ui/ArrayFieldBox';
import TextFieldRight from '../../ui/TextFieldRight';
import TextFieldButton from '../../ui/TextFieldButton';
import SelectPersonForm from './SelectPersonForm';
import BankPersonListForm from './BankPersonListForm';
import BankPersonForm from './BankPersonForm';
import EndDateCalculateForm from '../common/EndDateCalculateForm';
// import user Library.

import IBankPolicy, {ICoverage, ITarifInfo, defaultBankPolicy} from './model/BankPolicy';
import IGroupPolicy, {IProductByGroupPolicy} from './model/GroupPolicy';
import {IEnumerationItem} from '../configuration/model/Enumeration';

import IProduct, {defaultProduct} from '../product/model/Product';

import useBankPolicyService from './service/BankPolicy';
import useGroupPolicyService from './service/GroupPolicy';
import useEnumerationService from '../configuration/service/Enumeration';
import useProductService from '../product/service/Product';
import useService from '../utils/service';

import {useUserStore} from '../../library/store'; 
import {diffInYears} from '../../library/common';
import IBankPerson from './model/BankPerson';
import { isFalsy } from 'utility-types';



// const TextFieldRight = (props : any) => {
//   return(<TextField {...props} inputProps={{style: { textAlign: 'right' }}} /> );
// }
 
const label = (
  <span>I have read and agree to the&nbsp;
    <a
      href="/terms_and_conditions"
      target="_blank"
      onClick={() => {alert('0000');}}
    >
      Terms and Conditions
    </a>
  </span>);

const BankPolicyForm: FC<IBankPolicy> = (props: IBankPolicy = defaultBankPolicy) => {

  const { setCurrentEntity,currentUser, setIsBackendOperation, setCurrentObjectDataDef, setCurrentObjectKey } = useUserStore();
  const {language: lg, customerAgencyEnumerationCode: agencyEnumCode, agencies, groupPolicies} = currentUser;
  const navigate = useNavigate();

  const { t, i18n } = useTranslation();

  const {policyID} = useParams();
  
  const { enqueueSnackbar } = useSnackbar();

  const [_policyID, _setPolicyID] = useState<number>( Number( policyID || 0 ) );

  //_setPolicyID( Number( policyID || '0' ) );
  //console.log(_policyID);

  const {getLastErrorMessage} = useService();

  const methods = useForm<IBankPolicy>( {defaultValues:defaultBankPolicy} );

  const { register, setValue ,getValues ,watch, reset ,control , formState: { errors } } = methods;
  let {fields: coverages, append: appendCoverage, remove: removeCoverage} = useFieldArray<IBankPolicy,'coverages'>({
      control, 
      name: 'coverages'});

  let {fields: tarifInfos, remove: removeTarifInfo} = useFieldArray<IBankPolicy,'tarifInfos'>({
        control, 
        name: 'tarifInfos'});

  const [currentProductCode, setCurrentProductCode] = useState('');
  const [currentGroupPolicyID, setCurrentGroupPolicyID] = useState(0);

  const {getUserGroupPoliciesList, getUserAgenciesList, getGroupPolicyProductsList, getGroupPoliciesList} = useGroupPolicyService();
  const {getEnumerationItemsList, getEnumerationItemsLanguageList, getEnumerationItemsListBatch} = useEnumerationService();
  const {getProduct, getDefaultBankPolicy} = useProductService();


  const {isSuccess: isAllGroupPoliciesSuccess, status: allGroupPoliciesStatus,data: allGroupPolicies} = useQuery<IGroupPolicy[]>("groupPolicies",getGroupPoliciesList);

  
  const {data: enumItems} = useQuery<IEnumerationItem[]>(
    ['EnumerationItems', 'BankPolicy'], () => 
    getEnumerationItemsListBatch( ['CIVILITE','POLICY_STT', 'DURAT_UNIT','FRACTIONE', 'LANGUAGE','SIT_MATRIM',agencyEnumCode] ));

  const addPeriods : {period: string, add: (date: Date | number, amount: number) => Date}[] = 
    [
      {period: 'year', add: addYears},  {period: 'quate', add: addQuarters}, 
      {period: 'semes', add: (date: Date | number, amount: number) => addMonths(date, amount*6) },
      {period: 'month', add: addMonths}, {period: 'day', add: addDays}
    ];
  // const [ {isSuccess: isUserAgenciesSuccess, status: userAgenciesStatus,data : userAgencies },
  //         {isSuccess: isPolicyStatusSuccess, status: policyStatusStatus,data: allPolicyStatus},
  //         {isSuccess: isCivilitiesSuccess, status: civilitiesStatus,data: allCivilities},
  //         {isSuccess: isFrequenciesSuccess, status: frequenciesStatus,data: allFrequencies},
  //         {isSuccess: isSitMatSuccess, status: sitMatStatus,data: allSitMat},
  //         {isSuccess: isLanguagesSuccess, status: languagesStatus,data: allLanguages},

  //       ] = useQueries([
  //     {queryKey: ['userAgencies', currentUser.userName], queryFn: getUserAgenciesList},
  //     {queryKey: ['policyStatus'], queryFn: () => getEnumerationItemsList('POLICY_STT')},
  //     {queryKey: ['civilities'], queryFn: () => getEnumerationItemsList('CIVILITE')},
  //     {queryKey: ['paymentFrequencies'], queryFn: () => getEnumerationItemsList('FRACTIONE')},
  //     {queryKey: ['sitMats'], queryFn: () => getEnumerationItemsList('SIT_MATRIM')},
  //     {queryKey: ['languages'], queryFn: () => getEnumerationItemsLanguageList()},
  //   ]) as UseQueryResult<IEnumerationItem[]>[];

  

  //const {isSuccess: isUserAgenciesSuccess, status: userAgenciesStatus,data: userAgencies} = useQuery<IEnumerationItem[]>("userAgencies",getUserAgenciesList);
  //const {isSuccess: isPolicyStatusSuccess, status: policyStatusStatus,data: allPolicyStatus} = useQuery<IEnumerationItem[]>("policyStatus", () => getEnumerationItemsList('POLICY_STT'));
  //const {isSuccess: isCivilitiesSuccess, status: civilitiesStatus,data: allCivilities} = useQuery<IEnumerationItem[]>("civilities", () => getEnumerationItemsList('CIVILITE'));
  //const {isSuccess: isFrequenciesSuccess, status: frequenciesStatus,data: allFrequencies} = useQuery<IEnumerationItem[]>("paymentFrequencies", () => getEnumerationItemsList('FRACTIONE'));


  const {isSuccess: isGroupPolicyProductsSuccess, status: groupPolicyProductsStatus,data: groupPolicyProducts} = useQuery<IProductByGroupPolicy[]>("groupPolicyProducts", getGroupPolicyProductsList);

  // const {isSuccess: isProductSuccess, status: productStatus,refetch: refetchProduct,data: currentProduct} = 
  //     useQuery<IProduct>(['Product', currentProductCode], () => getProduct(currentProductCode), 
  //       {enabled: (currentProductCode !== '' && getValues().productCode !== currentProductCode /*&& currentProduct.productCode !== currentProductCode*/  ) } );

  // const {isSuccess: isDefaultBankPolicySuccess, status: defaultBankPolicyStatus,refetch: refetchDefaultBankPolicy,data: currentDefaultBankPolicy} = 
  //     useQuery<IBankPolicy>(['DefaultBankPolicy', currentGroupPolicyID ,currentProductCode], () => getDefaultBankPolicy(currentGroupPolicyID, currentProductCode), 
  //       {enabled: (currentGroupPolicyID > 0 && currentProductCode !== '') } );

  //console.log(result);

  const [currentProduct, setCurrentProduct] = useState<IProduct>();
  const [currentDefaultBankPolicy, setCurrentDefaultBankPolicy] = useState(defaultBankPolicy);

  const  {evaluateBankPolicyValue, saveBankPolicy, getBankPolicy} = useBankPolicyService();

  const queryClient = useQueryClient();
  const {isLoading, isError, isSuccess ,error,mutate } = useMutation<IBankPolicy,Error,IBankPolicy>(saveBankPolicy, 
    {        
      onSuccess: (data: IBankPolicy) => {
        enqueueSnackbar( t('_Operation_done') + '\n ID = ' + (data.policyID || 0).toString(), { variant: 'success',
              anchorOrigin : { horizontal: 'center', vertical: 'top' }, autoHideDuration : 1000 });           
        
        reset(data);
        setCurrentObjectKey( (data.policyID &&  data.policyID > 0) ? data.policyID.toString():'');
        queryClient.invalidateQueries(['BankPolicy',data.policyID]);
      },
      onError: async (err: Error) => { 
        const lastError = await getLastErrorMessage();       
        enqueueSnackbar( lastError, { variant: 'error',
              anchorOrigin : { horizontal: 'center', vertical: 'top' }, autoHideDuration : 2000,} );
      }
    });

    const {isLoading: isLoadingEvaluation, isError: isErrorEvaluation, isSuccess: isSuccessEvaluation, 
        error: errorEvaluation, mutate: mutateEvaluation } = useMutation<IBankPolicy,Error,IBankPolicy>(evaluateBankPolicyValue, 
      {        
        onSuccess: (data: IBankPolicy) => {
          enqueueSnackbar( t('_Evaluation_done'), { variant: 'success',
                anchorOrigin : { horizontal: 'center', vertical: 'top' }, autoHideDuration : 500 }); 
          
                console.log(data);
          reset(data);
        },
        onError: async (err: Error) => {  
          const lastError = await getLastErrorMessage();
          enqueueSnackbar( lastError + ' ' + err.message, { variant: 'error',
                anchorOrigin : { horizontal: 'center', vertical: 'top' }, autoHideDuration : 2000 });          
        }
      });
  
  const {data: _data,refetch} = useQuery<IBankPolicy>(['BankPolicy', _policyID], () => getBankPolicy( _policyID ), 
    {enabled: _policyID > 0 } );
  //const [isDataLaoding, setIsDataLoading] = useState(_policyID > 0);

  const [currentProducts, setCurrentProducts] = useState<IProductByGroupPolicy[]>(groupPolicyProducts || []);

  const [openCoveragesList, setOpenCoveragesList] = useState<boolean>(false);
  const [selectedCoverages, setSelectedCoverages] = useState<string[]>([]);

  const [openSelectPerson, setOpenSelectPerson] = useState<boolean>(false);
  const [openEditPerson, setOpenEditPerson] = useState<boolean>(false);

  const [openExpirationCalculate, setOpenExpirationCalculate] = useState<boolean>(false);
  
  const [isSelectRiskElement, setIsSelectRiskElement] = useState(false);
  const [disabledPayorSelect, setDisabledPayorSelect] = useState(false);


  const cellEditable = (row: ICoverage, cellId: keyof ICoverage) => {
  
    if(cellId === 'capital' && row.coverageEvaluationType?.startsWith('C@') ) return true;
    if(cellId === 'basePremium' && row.coverageEvaluationType?.startsWith('P@') ) return true;
    if(cellId === 'recCapital' && row.coverageEvaluationType?.startsWith('R@') ) return true;
    if(cellId === 'duePremium' && row.coverageEvaluationType?.startsWith('D@') ) return true;
  
  
    if(cellId === 'optionValue1' ) return true;
    if(cellId === 'optionValue2' ) return true;
    if(cellId === 'optionValue3' ) return true;
  
    return false;
   }
  
   const getOptionLabel = (row: ICoverage, cellId: keyof ICoverage) : string => {
      if(cellId === 'optionValue1') return row.optionPropertyText1 || '';
      if(cellId === 'optionValue2') return row.optionPropertyText2 || '';
      if(cellId === 'optionValue3') return row.optionPropertyText3 || '';
  
      return cellId as string;
   }
  
   const getOptionEnumerationCode = (row: ICoverage, cellId: keyof ICoverage) : string => {
    if(cellId === 'optionValue1') return row.optionValueList1 || '';
    if(cellId === 'optionValue2') return row.optionValueList2 || '';
    if(cellId === 'optionValue3') return row.optionValueList3 || '';
  
    return cellId as string;
  }
  
   const getOptionOptions = (row: ICoverage, cellId: keyof ICoverage) : {value: string, name: string}[] => {
    if(cellId === 'optionValue1') return row.options1 || [];
    if(cellId === 'optionValue2') return row.options2 || [];
    if(cellId === 'optionValue3') return row.options3 || [];
  
    return [];
  }
  
  const getOptionVisibility = (row: ICoverage, cellId: keyof ICoverage) : boolean => {
    if(cellId === 'optionValue1') return (row.optionPropertyName1 || '') !== '';
    if(cellId === 'optionValue2') return (row.optionPropertyName2 || '') !== '';
    if(cellId === 'optionValue3') return (row.optionPropertyName3 || '') !== '';
  
    return false;
  }

   const [headCoverageCells, setHeadCoverageCells]  = useState<HeadCell<ICoverage>[]>([
    //{id:'coverageCode', label : t('Code'),  display: true, type: 'string'},
    {id:'coverageName', label : t('Coverage'),  display: true, type: 'string', width: 40},
    {id:'capital', label : t('Capital'),  display: true, type: 'numeric', isEditable: cellEditable, width: 10},
    {id:'recCapital', label : t('Capital_Rec'),  display: true, type: 'numeric', isEditable: cellEditable, width: 10}, 
    {id:'basePremium', label : t('Base_Premium'),  display: true, type: 'numeric', isEditable: cellEditable, width: 10},
    {id:'netPremium', label : t('Net_Premium'),  display: true, type: 'numeric', isEditable: cellEditable, width: 10},
    {id:'tax', label : t('Tax'),  display: true, type: 'numeric', width: 10}, 
    {id:'duePremium', label : t('Due_Premium'),  display: true, type: 'numeric', isEditable: cellEditable, width: 10},  

    {id:'optionValue1', label : 'optionPropertyText1',  display: false, type: 'dynamic', isEditable: cellEditable,
       getLabel: getOptionLabel, getEnumerationCode: getOptionEnumerationCode, getOptions: getOptionOptions, getVisibility: getOptionVisibility},
    {id:'optionValue2', label : 'optionPropertyText2',  display: false, type: 'dynamic', isEditable: cellEditable,
      getLabel: getOptionLabel, getEnumerationCode: getOptionEnumerationCode, getOptions: getOptionOptions, getVisibility: getOptionVisibility},
    {id:'optionValue3', label : 'optionPropertyText3',  display: false, type: 'dynamic', isEditable: cellEditable,
      getLabel: getOptionLabel, getEnumerationCode: getOptionEnumerationCode, getOptions: getOptionOptions, getVisibility: getOptionVisibility},
]);

const coverageRowDisplayMore = (field: FieldArrayWithId<IBankPolicy, ArrayPath<IBankPolicy> >, coverage: ICoverage) : boolean => {
  const {optionPropertyName1,optionPropertyName2,optionPropertyName3} = coverage;

  return ((optionPropertyName1 || '') !== '') ||  
          ((optionPropertyName2 || '') !== '') ||
          ((optionPropertyName3 || '') !== '');
}

const coverageRowActionIcon = (coverage: ICoverage) : ActionIconTableRow<IBankPolicy,ICoverage> => {
  
  const {optionPropertyName1,optionPropertyName2,optionPropertyName3} = coverage;

  const res: ActionIconTableRow<IBankPolicy,ICoverage> = {
    toolTip: 'viewDetails',
    icon: InsightsIcon,
    hasAction:  ((optionPropertyName1 || '') !== '') ||  
                ((optionPropertyName2 || '') !== '') ||
                ((optionPropertyName3 || '') !== ''),
    isActionExecuting: true,
    onRowClickIcon: (event : any, index: number ,row: ICoverage) => {
      //setOpenCoverageOption(true);
      // row['optionValue1'] = '100';
      // row['optionValue2'] = '200';
      // row['optionValue2'] = '300';
      console.log(index);
      //console.log(row);
    }
  }

  return res;
}

  const watchGroupPolicy = watch("groupPolicyID");
  const watchProduct = watch("productCode");
  const watchIsInsurerPayor = watch("isInsuredPayor");

  const watchPaymentFrequency = watch("paymentFrequency");
  const watchEffectiveDate = watch("effectiveDate");
  const watchExpirationDate = watch("expirationDate");
  const watchReimbursementDateAuto = watch("reimbursementDateAuto");

  const watchDuration = watch("duration");
  const watchDurationUnit = watch("durationUnit");
  
  
  useEffect( () => {
    setCurrentEntity(t('BankPolicy'));
    setCurrentObjectDataDef('00115'); //
    setCurrentObjectKey( _policyID<=0? '':_policyID.toString());
    
    if( currentUser.userMenus.find( x => x.entity === 'BankPolicy') === undefined)
        navigate('/');

        // else if(_policyID <= 0)
    //   reset(defaultBankPolicy);

  }, [_policyID] );

  useEffect( () => { 
    const data = getValues();
    const tmpPolicyID = data.policyID || 0;
    if(_policyID !== tmpPolicyID) {    //console.log('useEffect ...'); console.log(_data);  
      
      if(enumItems && (_data?.policyID || 0) > 0 && 
        !enumItems.filter( e => e.enumerationCode === agencyEnumCode && agencies.some(a => a.agencyCode === e.enumerationItemCode) ).some( ag => ag.enumerationItemCode === _data?.agencyCode )) {
        enqueueSnackbar( t('You can not access data for this agency') , { variant: 'warning',
          anchorOrigin : { horizontal: 'center', vertical: 'top' }, autoHideDuration : 5000 });
        navigate('/bankPolicyList');
        return;
      }
      reset(_data);
      //setIsDataLoading(false); 
    }
  }, [_data, reset]);

  useEffect( () => {
    setIsBackendOperation(isLoading);
  }, [isLoading]);

  // useEffect( () => {
  //   setIsBackendOperation(isLoading);
  // }, [isLoading]);

  useEffect( () => {
    
     console.log('start date'); 
     console.log({watchEffectiveDate,watchDuration,watchDurationUnit}); 

     if(isFalsy(watchDuration)) return;
     if(isFalsy(watchDurationUnit)) return;

     const {effectiveDate} = getValues();
     //console.log(watchDuration); console.log(watchDurationUnit);
     const add = addPeriods.find(f => f.period === watchDurationUnit)?.add || addYears;
    console.log({add, dur: watchDuration || 1, end: add(watchEffectiveDate, watchDuration || 1),
          endP: addDays( add( new Date(effectiveDate), watchDuration || 1), - 1),
          andA: addYears(effectiveDate, 1)
     }); //console.log(add);
    //  console.log(add(startDate,getDurationValues().duration || 1));
     const endDate = addDays( add( new Date(watchEffectiveDate), watchDuration || 1), - 1);
     console.log(endDate);
     setValue('expirationDate', endDate  );
  
  }, [watchEffectiveDate, watchDuration, watchDurationUnit] );

  useEffect(() => {    
    
    const data = getValues();
    const groupPolicyID = data.groupPolicyID || 0;    
    
    setCurrentGroupPolicyID(groupPolicyID);

    if(groupPolicyProducts && groupPolicyID && groupPolicyID > 0) {
      const arr = groupPolicyProducts.filter(x => x.groupPolicyID === groupPolicyID);
      setCurrentProducts([...arr]);    
    }
  }, [watchGroupPolicy]);

  useEffect(() => {    
    async function loadDefaultBankPolicy() {

      console.log('loadDefaultBankPolicy ');
      const data = getValues();
      const productCode = data.productCode || '';    
      const groupPolicyID = data.groupPolicyID || 0;    

      if( productCode !== '' && (!currentProduct || (currentProduct && currentProduct.productCode !== productCode))){
       // alert('isDataLaoding' + productCode);
        const p = await getProduct(productCode);
        setCurrentProduct(p);   
        console.log(p);     
      }            

      console.log({productCode, groupPolicyID, _groupPolicyID:currentDefaultBankPolicy.groupPolicyID, currentDefaultBankPolicy});
      if(productCode !== '' && groupPolicyID > 0 && 
        (currentDefaultBankPolicy.productCode !== productCode || currentDefaultBankPolicy.groupPolicyID !== groupPolicyID) &&         
        ( ( !_data )
            ||
          ( _data && (_data.productCode !== productCode || currentDefaultBankPolicy.productCode !== ''))
        )) {
          
          const bp = await getDefaultBankPolicy(groupPolicyID, productCode);
          
          setCurrentDefaultBankPolicy({...bp,reimbursementDateAuto: true});
          removeTarifInfo();
          removeCoverage();
          reset({...bp,reimbursementDateAuto: true});
        }
    }
    
    console.log('watchProduct');
    //if(!isDataLaoding)
      loadDefaultBankPolicy();
    // else
    //   setIsDataLoading(false);

  }, [watchProduct]);

  

  useEffect(() => {    
    const data = getValues();
    setDisabledPayorSelect(data.isInsuredPayor || false);

    if(data.isInsuredPayor) {
      
      setValue('payorCivility',data.civility);
      setValue('payorMaritalSituation',data.maritalSituation);
      setValue('payorDefaultLanguage',data.defaultLanguage); // data.
      setValue('payorFirstName',data.firstName);
      setValue('payorLastName',data.lastName);
      setValue('payorDefaultLanguage',data.defaultLanguage);
      setValue('payorEmail1',data.email1);
      setValue('payorPortable1',data.portable1);
      setValue('payorBirthDate',data.birthDate);
      setValue('payorBirthPlace',data.birthPlace);
    }

  }, [watchIsInsurerPayor]);

  useEffect(() => {    
    const data = getValues();
    
    if(data.paymentFrequency === '00000') {
      setValue('paymentDuration',1);
    }

    let expir: Date = new Date();
    let effec: Date = new Date();

    if(data?.expirationDate && data?.effectiveDate) {
      expir = new Date(data?.expirationDate);
      effec = new Date(data?.effectiveDate);
    } else return;

    if(data.paymentFrequency === '00001') {

      if(currentProduct?.isAutoPaymentDuration && data?.expirationDate && data?.effectiveDate) {        

        setValue('paymentDuration',diffInYears(effec, expir));
      }
    }

    if(data.paymentFrequency === '00012') {
      if(currentProduct?.isAutoPaymentDuration && data?.expirationDate && data?.effectiveDate) {

        setValue('paymentDuration',differenceInCalendarMonths(data?.expirationDate, data?.effectiveDate));
      }
    }

    if(data.reimbursementDateAuto) {
      setValue("reimbursementStartDate", data.effectiveDate);
      setValue("reimbursementEndDate", data.expirationDate);
      setValue("reimbursementDuration", differenceInCalendarMonths(expir, effec));
    }

  }, [watchPaymentFrequency, watchEffectiveDate, watchExpirationDate]);

  useEffect(() => {    
    const data = getValues();
    
    if(data.reimbursementDateAuto) {
      setValue("reimbursementStartDate", data.effectiveDate);
      setValue("reimbursementEndDate", data.expirationDate);

      let expir: Date = new Date();
      let effec: Date = new Date();

      if(data?.expirationDate && data?.effectiveDate) {
        expir = new Date(data?.expirationDate);
        effec = new Date(data?.effectiveDate);
      } else return;

      setValue("reimbursementDuration", differenceInCalendarMonths(expir, effec));
    }

  }, [watchReimbursementDateAuto]);

  // useEffect( () => {
  //   if(isErrorEvaluation) {
  //     console.log('.... errorEvaluation ...... ');
  //     console.log(errorEvaluation?.name);
  //     console.log(errorEvaluation);
  //     alert(errorEvaluation);
  //   }
  // }, [isErrorEvaluation,errorEvaluation]);
  

  const handleOkCoveragesList = () => {

    setOpenCoveragesList(false);

    if(currentProduct && currentProduct.coverages && selectedCoverages.length > 0) {
      const arr = currentProduct.coverages.filter( x => selectedCoverages.includes(x.coverageCode));

      appendCoverage( arr.map( c => ({...c, capital: 0, netPremium:0, duePremium: 0, tax1: 0} ))); 
    }
  }

  const handleAddCoverages = (event: any) => {
      setOpenCoveragesList(true);  
    }

  const handleEvaluateCoverages = (event: any) => {
    const data = getValues();       

    if(!data.paymentDuration || data.paymentDuration <= 0) {
      enqueueSnackbar( t('Payment duration is not define') , { variant: 'error',
        anchorOrigin : { horizontal: 'center', vertical: 'top' }, autoHideDuration : 1500 });
      return;
    }

    if(!data.paymentFrequency || data.paymentFrequency === '') {
      enqueueSnackbar( t('Payment frequency is not define') , { variant: 'error',
        anchorOrigin : { horizontal: 'center', vertical: 'top' }, autoHideDuration : 1500 });
      return;
    }

    // if( (!data.riskElementID && !data.bankRiskElementID) || (data && data.riskElementID <= 0 && data.bankRiskElementID <= 0)) {
    //   enqueueSnackbar( 'risk Element is not define ...' , { variant: 'error',
    //     anchorOrigin : { horizontal: 'center', vertical: 'top' }, autoHideDuration : 1500 });
    //   return;
    // }

    //console.log(data);
    mutateEvaluation(data);
  }

  const handleClickPickRiskElement = () => {
    setIsSelectRiskElement(true);
    setOpenSelectPerson(true);  
  }

  const handleClickEditRiskElement = () => {
    setIsSelectRiskElement(true);
    setOpenEditPerson(true);  
  }

  const handleClickPickPayor = () => {    
    setIsSelectRiskElement(false);
    setOpenSelectPerson(true);  
  }

  const handleClickEditPayor = () => {
    setIsSelectRiskElement(false);
    setOpenEditPerson(true);  
  }
  
  const handleOkEditPerson = () => {
    setOpenEditPerson(false); 
  }

  const handleClickExpirationCalculate = (event: any) => {
    setOpenExpirationCalculate(true);  
  }

  

  // this will be executed when person is selected in list ...
  const handleBankPersonRowDoubleClick = (event: React.MouseEvent<unknown>, bankPerson: IBankPerson) => {
    setOpenSelectPerson(false);
      
    setValue(isSelectRiskElement?'firstName':'payorFirstName', bankPerson.firstName);
    setValue(isSelectRiskElement?'lastName':'payorLastName', bankPerson.lastName);
    //setValue(isSelectRiskElement?'firstName':'payorFirstName', bankPerson.firstName);

    setValue(isSelectRiskElement?'civility':'payorCivility', bankPerson.civility);
    setValue(isSelectRiskElement?'maritalSituation':'payorMaritalSituation', bankPerson.maritalSituation);
    setValue(isSelectRiskElement?'defaultLanguage':'payorDefaultLanguage', bankPerson.defaultLanguage);
    setValue(isSelectRiskElement?'birthDate':'payorBirthDate', bankPerson.birthDate);
    setValue(isSelectRiskElement?'birthPlace':'payorBirthPlace', bankPerson.birthPlace);
    
    setValue(isSelectRiskElement?'portable1':'payorPortable1', bankPerson.portable1);
    setValue(isSelectRiskElement?'email1':'payorEmail1', bankPerson.email1);             
  }

  const getEffectiveDate = () : Date => 
    new Date( getYear(getValues().effectiveDate), getMonth(getValues().effectiveDate)+1, getDate(getValues().effectiveDate))

  const saveData = async (event: MouseEvent<HTMLButtonElement>) => {

    const data = getValues();   

    if(!data.paymentDuration || data.paymentDuration <= 0) {
      enqueueSnackbar( t('Payment duration is not define') , { variant: 'error',
        anchorOrigin : { horizontal: 'center', vertical: 'top' }, autoHideDuration : 1500 });
      return;
    }

    if(!data.paymentFrequency || data.paymentFrequency === '') {
      enqueueSnackbar( t('Payment frequency is not define') , { variant: 'error',
        anchorOrigin : { horizontal: 'center', vertical: 'top' }, autoHideDuration : 1500 });
      return;
    }

    mutate(data);
  }

  const newData = async (event: MouseEvent<HTMLButtonElement>) => {

    setCurrentProduct(defaultProduct);
    setCurrentDefaultBankPolicy(defaultBankPolicy);
    reset( {...defaultBankPolicy} );
  }

  const listData = async (event: MouseEvent<HTMLButtonElement>) => {
    navigate('/bankPolicyList');
  }

  const afterAction = async (event: MouseEvent<HTMLButtonElement>) => {
    
    const data = await getBankPolicy(_policyID);
    reset(data);
  }

    return (
      <>
        <FormProvider {...methods} >
          <Grid container component="main" sx={{  width: '100%' }} alignItems="flex-start">
            <Grid item xs={12} sm={6} md={4} component={Paper} elevation={0} sx={{ borderRadius: 2, ml: 0, }}>
              <Box sx={{ display: 'flex', flexDirection: 'column', alignItems: 'center', alignContent:'center', width: '100%' }} >
                <Box sx={{ mt: 1, width: '100%' }} >  
                  <Controller name='groupPolicyID' control={control} defaultValue={-1}
                      render={ ({field: {onChange, value}}) => (
                        <TextField select required onChange={onChange} value={value ?? -1} sx={{width:'calc(50% - 8px)'}} id="groupPolicyID" label={t('GroupPolicy')}>
                          {!allGroupPolicies && <MenuItem key={-1} value={-1}>{'<<>>'}</MenuItem>}
                          {allGroupPolicies && allGroupPolicies.filter( grp => groupPolicies.some(g => grp.groupPolicyID === g.groupPolicyID) ).map( 
                            (ei,idx) => <MenuItem key={ei.groupPolicyID} value={ei.groupPolicyID}>{ei.groupContractName}</MenuItem> )
                          }
                        </TextField>
                      )}
                  />                                     
                  <Controller name='productCode' control={control} defaultValue=''
                      render={ ({field: {onChange, value}}) => (
                        <TextField select required onChange={onChange} value={value} sx={{width:'calc(50% - 8px)'}} id="productCode" label={t('Product')}>
                          {!currentProducts && <MenuItem key={''} value={0}>{'<<>>'}</MenuItem>}
                          {currentProducts && currentProducts.map( 
                            (prd,idx) => <MenuItem key={prd.productCode} value={prd.productCode}>{prd.productName}</MenuItem> )
                          }
                        </TextField>
                      )}
                  />     
                  <Button id='btnNew' onClick={newData} sx={ {display:'none'}}  />                                  
                  <Button id='btnSave' onClick={saveData} sx={ {display:'none'}}  />
                  <Button id='btnList' onClick={listData} sx={ {display:'none'}}  />
                  <Button id='btnAfterAction' onClick={afterAction} sx={ {display:'none'}}  />
                </Box>     
                <Box sx={{ mt: 1, width: '100%' }} >   
                  <Controller name='agencyCode' control={control} defaultValue=''
                      render={ ({field: {onChange, value}}) => (
                        <TextField select required onChange={onChange} value={value} sx={{width:'calc(33% - 8px)'}} id="agencyCode" label={t('Agency')}>
                        {enumItems && enumItems.filter( e => e.enumerationCode === agencyEnumCode && agencies.some(a => a.agencyCode === e.enumerationItemCode ) ).map( 
                          (ei,idx) => <MenuItem key={ei.enumerationItemCode} value={ei.enumerationItemCode}>{ei.enumerationItemName}</MenuItem> )
                        }
                        </TextField>
                      )}
                  /> 
                  <TextField  sx={{width:'calc(33% - 8px)'}} id="accountNumber" label={t('Account_Number')} {...register('accountNumber')} />     
                  <TextField  sx={{width:'calc(34% - 8px)'}} id="loanNumber" label={t('Loan_Number')} {...register('loanNumber')} />     
                </Box>    
                <Box sx={{ mt: 1, width: '100%' }} >                                       
                  <TextField  sx={{width:'calc(33% - 8px)'}} id="contractNumberManual" label="Contract Number Manual" {...register('contractNumberManual')}/>     
                  <TextField  sx={{width:'calc(33% - 8px)'}} id="contractNumberExternal" label="Contract Number External" {...register('contractNumberExternal')}/>     
                  <TextField  sx={{width:'calc(34% - 8px)'}} id="contractNumberValidation" label="Contract Number Validation" {...register('contractNumberValidation')} inputProps={ {readOnly: true}}/>     
                </Box> 
                <Box sx={{ mt: 1, width: '100%' }} >  
                  <Controller name='policyStatus' control={control} 
                      render={ ({field: {onChange, value}}) => (
                        <TextField select onChange={onChange} value={value} sx={{width:'calc(33% - 8px)'}} id="policyStatus" label={t('Status')} inputProps={ {readOnly: true}}>
                        {enumItems && enumItems.filter( e => e.enumerationCode === 'POLICY_STT').map( 
                          (ei,idx) => <MenuItem key={ei.enumerationItemCode} value={ei.enumerationItemCode}>{ei.enumerationItemName}</MenuItem> )
                        }
                        </TextField>
                      )}
                  />     
                  <Controller control={control}
                    name='policyStatusDate' 
                    render={({ field: { onChange, onBlur, value, ref } }) => (
                      <DatePicker label={t('Status Date')} readOnly
                        onChange={onChange}                        
                        value={value}
                        renderInput={(params) => <TextField {...params} sx={{width:'calc(33% - 8px)'}} />}
                      /> )}
                  />
                  <TextField  sx={{width:'calc(34% - 8px)'}} id="contractNumber" label={t('ContractNumber')} {...register('contractNumber')} inputProps={ {readOnly: true}}/>     
                </Box>      
              </Box>               
            </Grid>        
            <Grid item xs={12} sm={6} md={4} component={Paper} elevation={0} square>
              <Box sx={{ display: 'flex', flexDirection: 'column', alignItems: 'center', width: '100%' }} >
                <Box sx={{ mt: 1, width: '100%' }} >
                  <Controller name='civility' control={control} defaultValue=''
                      render={ ({field: {onChange, value}}) => (
                        <TextField select required onChange={onChange} value={value} sx={{width:'calc(33% - 8px)'}} id="civility" label={t('Civility')} >
                        {enumItems && enumItems.filter( e => e.enumerationCode === 'CIVILITE').map( 
                          (cv,idx) => <MenuItem key={cv.enumerationItemCode} value={cv.enumerationItemCode}>{cv.enumerationItemName}</MenuItem> )
                        }
                        </TextField>
                      )}
                  />
                  <Controller name='maritalSituation' control={control} defaultValue=''
                      render={ ({field: {onChange, value}}) => (
                        <TextField select onChange={onChange} value={value} sx={{width:'calc(33% - 8px)'}} id="maritalSituation" label={t('Mat. Sit.')}>
                        {enumItems && enumItems.filter( e => e.enumerationCode === 'SIT_MATRIM').map( 
                          (sm,idx) => <MenuItem key={sm.enumerationItemCode} value={sm.enumerationItemCode}>{sm.enumerationItemName}</MenuItem> )
                        }
                        </TextField>
                      )}
                    />
                  <Controller name='defaultLanguage' control={control} defaultValue=''
                        render={ ({field: {onChange, value}}) => (
                          <TextField select required onChange={onChange} value={value} sx={{width:'calc(34% - 8px)'}} id="defaultLanguage" label={t('Language')}>
                          {enumItems && enumItems.filter( e => e.enumerationCode === 'LANGUAGE').map( 
                            (lg,idx) => <MenuItem key={lg.enumerationItemCode} value={lg.enumerationItemCode}>{lg.enumerationItemName}</MenuItem> )
                          }
                          </TextField>
                        )}
                    />                       
                </Box>
                <Box sx={{ mt: 1, width: '100%' }} >   
                  <TextField  required sx={{width:'calc(50% - 8px)'}} id={lg.startsWith('fr')?'lastName':'firstName'} label={t(lg.startsWith('fr')?'Last Name':'First Name')} {...register(lg.startsWith('fr')?'lastName':'firstName')} />                                  
                  <TextField  sx={{width:'calc(50% - 8px)'}} id={lg.startsWith('fr')?'firstName':'lastName'} label={t(lg.startsWith('fr')?'First Name':'Last Name')} {...register(lg.startsWith('fr')?'firstName':'lastName')} />                                                         
                  { openSelectPerson && <FormDialog open={openSelectPerson} maxWidth='md'
                      okText='' cancelText='' title={t('Select Person')} onCancel={()=> {setOpenSelectPerson(false);}} onOk={()=> {setOpenSelectPerson(false);}} 
                      onClose={()=> {setOpenSelectPerson(false);}}   >
                      <Box sx={{ mt: 1, width: '100%' }} >
                        <BankPersonListForm onRowDoubleClick={handleBankPersonRowDoubleClick} /> 
                      </Box>
                    </FormDialog> }
                    { openEditPerson && <FormDialog open={openEditPerson} maxWidth='md'
                      okText='OK' cancelText='' title={t('Edit Person')} onCancel={()=> {setOpenEditPerson(false);}} 
                      onClose={()=> {setOpenEditPerson(false);}} onOk={()=> {setOpenEditPerson(false);}}  >
                      <Box sx={{ mt: 1, width: '100%' }} >
                        <BankPersonForm  /> 
                      </Box>
                    </FormDialog> }
                </Box>
                <Box sx={{ mt: 1, width: '100%' }} >  
                  <Controller control={control}
                      name='birthDate' 
                      render={({ field: { onChange, onBlur, value, ref } }) => (
                        <DatePicker label={t('Birth Date')}
                          onChange={onChange} value={value}
                          renderInput={(params) => <TextField required {...params} sx={{width:'calc(30% - 8px)'}}  />}
                        /> )}
                  />                                     
                  <TextField  sx={{width:'calc(70% - 8px)'}} id="birthPlace" label={t('BirthPlace')} {...register('birthPlace')}  />     
                </Box>
                <Box sx={{ mt: 1, width: '100%' }} >  
                  <TextField  sx={{width:'calc(30% - 8px)'}} id="portable1" label={t('Portable1')}  {...register('portable1')}  />                                  
                  <TextField  sx={{width:'calc(70% - 8px)'}} id="email1" label={t('Email1')} {...register('email1')} 
                    inputProps={ { autoComplete: 'new-password', style: {textTransform: 'none'} } }
                    InputProps={{
                      endAdornment: (
                        <InputAdornment position="end">
                          <>
                            <IconButton color="primary" onClick={handleClickEditRiskElement}>
                              <ModeEditIcon />
                            </IconButton>
                            <IconButton color="primary" onClick={handleClickPickRiskElement}>
                              <SearchIcon />
                            </IconButton>
                          </>
                        </InputAdornment>
                      )
                    }} />     
                </Box>
              </Box>
            </Grid>
            <Grid item xs={12} sm={6} md={4} component={Paper} elevation={0} square>
              <Box sx={{ display: 'flex', flexDirection: 'column', alignItems: 'center', width: '100%' }} >
                <Box sx={{ mt: 1, width: '100%' }} >                                       
                  <Controller name='payorCivility' control={control} defaultValue=''
                      render={ ({field: {onChange, value}}) => (
                        <TextField select required onChange={onChange} value={value} sx={{width:'calc(33% - 8px)'}} id="payorCivility" label={t('PayorCivility')} >
                        {enumItems && enumItems.filter( e => e.enumerationCode === 'CIVILITE').map( 
                          (cv,idx) => <MenuItem key={cv.enumerationItemCode} value={cv.enumerationItemCode}>{cv.enumerationItemName}</MenuItem> )
                        }
                        </TextField>
                      )}
                  />
                  <Controller name='payorMaritalSituation' control={control} defaultValue=''
                      render={ ({field: {onChange, value}}) => (
                        <TextField select onChange={onChange} value={value} sx={{width:'calc(33% - 8px)'}} id="payorMaritalSituation" label={t('Payor Mat. Sit.')}>
                        {enumItems && enumItems.filter( e => e.enumerationCode === 'SIT_MATRIM').map( 
                          (sm,idx) => <MenuItem key={sm.enumerationItemCode} value={sm.enumerationItemCode}>{sm.enumerationItemName}</MenuItem> )
                        }
                        </TextField>
                      )}
                    />
                 <FormControlLabel sx={{width:'calc(34% - 8px)'}}
                    label='Assuré = Payeur'
                    control={
                      <Controller
                        name='isInsuredPayor'
                        control={control}
                        render={({ field }) => <Checkbox {...field} />}                        
                      />
                    }
                  />
                </Box>
                <Box sx={{ mt: 1, width: '100%' }} >     
                  <TextField  required sx={{width:'calc(50% - 8px)'}} id={lg.startsWith('fr')?'payorLastName':'payorFirstName'} label={t(lg.startsWith('fr')?'Payor Last Name':'Payor First Name')} {...register(lg.startsWith('fr')?'payorLastName':'payorFirstName')} />                                  
                  <TextField  sx={{width:'calc(50% - 8px)'}} id={lg.startsWith('fr')?'payorFirstName':'payorLastName'} label={t(lg.startsWith('fr')?'Payor First Name':'Payor Last Name')} {...register(lg.startsWith('fr')?'payorFirstName':'payorLastName')} />                                                         
     
                </Box>
                <Box sx={{ mt: 1, width: '100%' }} >  
                  <Controller control={control}  name='payorBirthDate' 
                      render={({ field: { onChange, onBlur, value, ref } }) => (
                        <DatePicker label='Date Naiss. Payeur'  readOnly
                          onChange={onChange}                        
                          value={value}
                          renderInput={(params) => <TextField {...params} sx={{width:'calc(30% - 8px)'}} />}
                        /> )}
                  />                                     
                  <TextField  sx={{width:'calc(40% - 8px)'}} id="payorBirthPlace" label={t('PayorBirthPlace')} {...register('payorBirthPlace')} inputProps={ {readOnly: true}} />     
                  <Controller name='payorDefaultLanguage' control={control} defaultValue=''
                        render={ ({field: {onChange, value}}) => (
                          <TextField select onChange={onChange} value={value} sx={{width:'calc(30% - 8px)'}} id="payorDefaultLanguage" label={t('Language')}>
                          {enumItems && enumItems.filter( e => e.enumerationCode === 'LANGUAGE').map( 
                            (lg,idx) => <MenuItem key={lg.enumerationItemCode} value={lg.enumerationItemCode}>{lg.enumerationItemName}</MenuItem> )
                          }
                          </TextField>
                        )}
                    />
                </Box>
                <Box sx={{ mt: 1, width: '100%' }} >  
                  <TextField  sx={{width:'calc(30% - 8px)'}} id="payorPortable1" label={t('Portable1')} {...register('payorPortable1')} inputProps={ {readOnly: true}} />                                  
                  <TextField  sx={{width:'calc(70% - 8px)'}} id="payorEmail1" label={t('Email1')} {...register('payorEmail1')}
                     inputProps={ {readOnly: true}}
                     InputProps={{
                      endAdornment: (
                        <InputAdornment position="end">
                          <>
                            <IconButton color="primary" onClick={handleClickEditPayor}>
                              <ModeEditIcon />
                            </IconButton>
                            <IconButton color="primary" onClick={handleClickPickPayor}>
                              <SearchIcon />
                            </IconButton>
                          </>
                        </InputAdornment>
                      )
                    }}/>       
                </Box>
              </Box>
            </Grid> 
            <Grid item xs={12} sm={4}  component={Paper} elevation={0} sx={ {height: 400} } square>
              <Box sx={{ display: 'flex', flexDirection: 'column', alignItems: 'center', width: '100%' }} >
                <Box sx={{ mt: 1, width: '100%' }} >                                       
                  <Controller control={control}
                      name='effectiveDate' 
                      render={({ field: { onChange, onBlur, value, ref } }) => (
                        <DatePicker label={t('EffectiveDate')}
                          onChange={onChange}                        
                          value={value}
                          renderInput={(params) => <TextField {...params} sx={{width:'calc(33% - 8px)'}} />}
                        /> )}
                  /> 
                  <Controller control={control}
                      name='loanDate' 
                      render={({ field: { onChange, onBlur, value, ref } }) => (
                        <DatePicker label={t('LoanDate')} 
                          onChange={onChange}                        
                          value={value}
                          renderInput={(params) => <TextField {...params} sx={{width:'calc(33% - 8px)'}} />}
                        /> )}
                  />
                  <Controller control={control}
                      name='policySetupDate' 
                      render={({ field: { onChange, onBlur, value, ref } }) => (
                        <DatePicker label={t('SetupDate')} 
                          onChange={onChange}                        
                          value={value}
                          renderInput={(params) => <TextField {...params} sx={{width:'calc(34% - 8px)'}} />}
                        /> )}
                  />
                </Box>
                <Box sx={{ mt: 1, width: '100%' }} >    
                  <IconButton color="primary" sx={{width:'calc(6% - 2px)', paddingTop:'12px'}} onClick={handleClickExpirationCalculate}>
                    <ModeEditIcon />
                  </IconButton>         
                  { openExpirationCalculate && <FormDialog open={openExpirationCalculate} maxWidth='xs' height = '50vh'
                      okText='OK' cancelText='' title={t('ExpirationDate')} onCancel={()=> {setOpenExpirationCalculate(false);}} 
                      onClose={()=> {setOpenExpirationCalculate(false);}} onOk={()=> {setOpenExpirationCalculate(false);}}  >
                      <Box sx={{ mt: 1, width: '100%' }} >
                        {/* <EndDateCalculateForm<IBankPolicy> startDate={getEffectiveDate()} startDateKey='effectiveDate' endDateKey='expirationDate' 
                          getContextValues={getValues} setContextValue={setValue}  />  */}
                      </Box>
                      <Box sx={{ mt: 1, width: '100%' }} >  
                        <Controller control={control}
                            name='effectiveDate'
                            render={({ field: { onChange, onBlur, value, ref } }) => (
                              <DatePicker label={t('EffectiveDate')}
                                onChange={onChange}                        
                                value={value}
                                renderInput={(params) => <TextField {...params} sx={{width:'calc(50% - 8px)'}} />}
                              /> )}
                        />                   
                      </Box>
                      <Box sx={{ mt: 1, width: '100%' }} >                    
                        <Controller
                          render={({ field }) => {
                            return (
                              <NumberFormat required             
                                label={t('Duration')}   sx={{width:'calc(30% - 8px)',  style: { textAlign: 'right' }}}                  
                                //decimalScale={2}
                                allowEmptyFormatting={false}
                                control={control}                          
                                //fixedDecimalScale={true}
                                thousandSeparator={true}
                                {...field}
                                customInput={TextFieldRight}
                              />
                            );
                          }}
                          name='duration'
                          control={control}
                        />                                     
                        <Controller name='durationUnit' control={control} defaultValue=''
                            render={ ({field: {onChange, value}}) => (
                              <TextField select required onChange={onChange} value={value} sx={{width:'calc(70% - 8px)'}} id="productCode" label={t('DurationUnit')}>
                              {enumItems && enumItems.filter( e => e.enumerationCode === 'DURAT_UNIT').map( 
                                (lg,idx) => <MenuItem key={lg.enumerationItemCode} value={lg.enumerationItemCode}>{lg.enumerationItemName}</MenuItem> )
                              }
                              </TextField>
                            )}
                        /> 
                      </Box>
                      <Box sx={{ mt: 1, width: '100%' }} >  
                        <Controller control={control}
                            name='expirationDate'
                            render={({ field: { onChange, onBlur, value, ref } }) => (
                              <DatePicker label={t('ExpirationDate')}
                                onChange={onChange}                        
                                value={value}
                                renderInput={(params) => <TextField {...params} sx={{width:'calc(50% - 8px)'}} />}
                              /> )}
                        />                   
                      </Box>
                    </FormDialog> }                          
                  <Controller control={control}
                      name='expirationDate' 
                      render={({ field: { onChange, onBlur, value, ref } }) => (
                        <DatePicker label={t('ExpirationDate')} 
                          onChange={onChange}                        
                          value={value}
                          showToolbar={true}
                          renderInput={(params) => <TextField {...params} 
                          sx={{width:'calc(27% - 8px)'}} />}
                          
                        /> )}
                  />
                  <Controller name='paymentFrequency' control={control}
                      render={ ({field: {onChange, value}}) => (
                        <TextField select onChange={onChange} value={value} sx={{width:'calc(33% - 8px)'}} id="paymentFrequency" label={t('PaymentFrequency')} >
                        {currentProduct && enumItems && enumItems.filter( e => e.enumerationCode === 'FRACTIONE').filter( x => currentProduct.allowedPaymentFrequency?.includes(x.enumerationItemCode)).map( 
                          (cv,idx) => <MenuItem key={cv.enumerationItemCode} value={cv.enumerationItemCode}>{cv.enumerationItemName}</MenuItem> )
                        }
                        
                        </TextField>
                      )}
                  />     
                  <Controller
                    render={({ field }) => {
                      return (
                        <NumberFormat required             
                          label={t('PaymentNumber')}   sx={{width:'calc(34% - 8px)',  style: { textAlign: 'right' }}}                  
                          //decimalScale={2}
                          allowEmptyFormatting={false}
                          control={control}                          
                          //fixedDecimalScale={true}
                          thousandSeparator={true}
                          {...field}
                          customInput={TextFieldRight}
                          //customInput={(props) => <TextField {...props} sx={{width:'calc(20% - 8px)'}} id="roleName" inputProps={{style: { textAlign: 'right' }}} />}
                        />
                      );
                    }}
                    name='paymentDuration'
                    control={control}
                  /> 
                  
                </Box>
                <Box sx={{ mt: 1, width: '100%' }} >  
                  <Controller control={control}
                      name='reimbursementStartDate' 
                      render={({ field: { onChange, onBlur, value, ref } }) => (
                        <DatePicker label={t('Reimb. Start Date')}
                          onChange={onChange}                        
                          value={value}
                          renderInput={(params) => <TextField {...params} sx={{width:'calc(33% - 8px)'}} />}
                        /> )}
                  />                                     
                  <TextField  sx={{width:'calc(17% - 8px)'}} id="reimbursementDuration"  label={t('Duration(Month)')} {...register('reimbursementDuration')} />     
                  <FormControlLabel sx={{width:'calc(16% - 8px)'}}
                    label='Auto.'
                    control={
                      <Controller
                        name='reimbursementDateAuto'
                        control={control}
                        render={({ field: {onChange, value} }) => <Checkbox onChange={onChange} checked={value} />}                      
                      />
                    }
                  />
                  <Controller control={control}
                      name='reimbursementEndDate' 
                      render={({ field: { onChange, onBlur, value, ref } }) => (
                        <DatePicker label={t('Reimb. End Date')}
                          onChange={onChange}                        
                          value={value}
                          renderInput={(params) => <TextField {...params} sx={{width:'calc(34% - 8px)'}} />}
                        /> )}
                  />
                </Box>                
              </Box>
              <ArrayFieldBox<ITarifInfo> params={tarifInfos} paramsName='tarifInfos' itemsPerRow={2} valueKey={'eltValue'} labelKey={'text'}  />
            </Grid> 
            <Grid item xs={12} sm={8}  component={Paper} elevation={0} sx={ {height: 400} } square>
              <Box sx={{ display: 'flex', flexDirection: 'column', alignItems: 'flex-start', width: '100%' }} >
                <Box sx={{ mt: 1, width: '100%' }} >  
                  <Controller
                    render={({ field }) => {
                      return (
                        <NumberFormat              
                          label={t('Net_Premium')} sx={{width:'calc(20% - 8px)'}} //disabled={true}                                         
                          
                          allowEmptyFormatting={false}
                          control={control}                          
                          //fixedDecimalScale={true}    
                          thousandSeparator={true}
                          //decimalSeparator={','}
                          decimalScale={2}
                          {...field}
                          customInput={TextFieldRight}
                          //customInput={(props) => <TextField {...props} sx={{width:'calc(20% - 8px)'}} id="roleName" inputProps={{style: { textAlign: 'right' }}} />}
                        />
                      );
                    }}
                    name='netPremium'
                    control={control}
                  />

                  <Controller
                    render={({ field }) => {
                      return (
                        <NumberFormat              
                          label={t('Tax')}  sx={{width:'calc(20% - 8px)'}} disabled={true}                                         
                          //decimalScale={2}
                          allowEmptyFormatting={false}
                          control={control}                          
                          //fixedDecimalScale={true}    
                          thousandSeparator={true}
                          //decimalSeparator={','}
                          decimalScale={2}
                          {...field}
                          customInput={TextFieldRight}
                          //customInput={(props) => <TextField {...props} sx={{width:'calc(20% - 8px)'}} id="roleName" inputProps={{style: { textAlign: 'right' }}} />}
                        />
                      );
                    }}
                    name='tax'
                    control={control}
                  />

                  <Controller
                    render={({ field }) => {
                      return (
                        <NumberFormat              
                          label={t('Accessories')}  sx={{width:'calc(20% - 8px)'}} disabled={true}                                           
                          //decimalScale={2}
                          allowEmptyFormatting={false}
                          control={control}                          
                          //fixedDecimalScale={true}    
                          thousandSeparator={true}
                          //decimalSeparator={','}
                          decimalScale={2}
                          {...field}
                          customInput={TextFieldRight}
                          //customInput={(props) => <TextField {...props} sx={{width:'calc(20% - 8px)'}} id="roleName" inputProps={{style: { textAlign: 'right' }}} />}
                        />
                      );
                    }}
                    name='accessories'
                    control={control}
                  />

                  <Controller
                    render={({ field }) => {
                      return (
                        <NumberFormat              
                          label={t('Acc. Tax')}  sx={{width:'calc(20% - 8px)'}} disabled={true}                                          
                          //decimalScale={2}
                          allowEmptyFormatting={false}
                          control={control}                          
                          //fixedDecimalScale={true}    
                          thousandSeparator={true}
                          //decimalSeparator={','}
                          decimalScale={2}
                          {...field}
                          customInput={TextFieldRight}
                          //customInput={(props) => <TextField {...props} sx={{width:'calc(20% - 8px)'}} id="roleName" inputProps={{style: { textAlign: 'right' }}} />}
                        />
                      );
                    }}
                    name='accessoriesTax'
                    control={control}
                  />

                  <Controller
                    render={({ field }) => {
                      return (
                        <NumberFormat              
                          label={t('Due_Amount')}  sx={{width:'calc(20% - 8px)'}} disabled={true}                                           
                          //decimalScale={2}
                          allowEmptyFormatting={false}
                          control={control}                          
                          //fixedDecimalScale={true}    
                          thousandSeparator={true}
                          //decimalSeparator={','}
                          decimalScale={2}
                          {...field}
                          customInput={TextFieldRight}
                          //customInput={(props) => <TextField {...props} sx={{width:'calc(20% - 8px)'}} id="roleName" inputProps={{style: { textAlign: 'right' }}} />}
                        />
                      );
                    }}
                    name='dueAmount'
                    control={control}
                  />                   
                </Box>  
                <Box sx={{ mt: 1, width: '100%' }} >                      
                  <ArrayFieldTable headCells={headCoverageCells} 
                    mainObject={getValues()}
                    rowsPathName='coverages' fieldKey='coverageCode'
                    title={t('Coverage(s)')} //onRowSelected={handleRoleItemSelected}
                    //displayMore={coverageRowDisplayMore}
                    toolbarActions={[ { toolTip: 'Evaluate..', onClickIcon: handleEvaluateCoverages ,icon: PriceCheckIcon, isActionExecuting:isLoadingEvaluation && !isErrorEvaluation  },
                                      { toolTip: 'Add..', onClickIcon: handleAddCoverages ,icon: AddCircleIcon },                                      
                                   ]} />       
                    { openCoveragesList && <FormDialog open={openCoveragesList} maxWidth='sm'
                      okText='OK' cancelText='Cancel' title={t('Select Coverage(s)')} onCancel={()=> {setOpenCoveragesList(false);}} 
                      onClose={()=> {setOpenCoveragesList(false);}} onOk={handleOkCoveragesList}  >
                      <Box sx={{ mt: 1, width: '100%' }} >
                        {currentProduct && <BasicSelectList  items={currentProduct.coverages.filter(c => !getValues().coverages.some(s => c.coverageCode === s.coverageCode) )} 
                          valueKey='coverageCode' displayKey='coverageName' setSelectedItems={setSelectedCoverages} title='Coverages' /> }
                      </Box>
                    </FormDialog> }           
                </Box>     
              </Box>
            </Grid>            
          </Grid>          
        </FormProvider>
      </>
    );
  }
  
  export default BankPolicyForm;